import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export default function PageWrapper({ children }: Props) {
  return (
    <div className="bg-gray-100 min-h-screen">
      {/* Outer background */}
      <div className="max-w-6xl mx-auto bg-white px-6 py-10 min-h-screen">
        {/* Inner content container */}
        {children}
      </div>
    </div>
  );
}